import React from "react";
import { Link, graphql } from "gatsby";
import { connect } from "react-redux";

import Layout from "../components/layout";
import StoryCard from "../components/StoryCard";
import SEO from "../components/seo";

// To do: map stories for each language
// To do: add SEO component

function LanguageStoriesCollection(props) {
  const { data } = props;
  debugger;
  return (
    <Layout>
      <SEO
        title={`English-${props.pageContext.secondLanguageName} Bilingual Stories`}
        description={`Read bilingual stories in English and ${props.pageContext.secondLanguageName} for FREE.`}
      />

      <div
        className="flex flex-col items-center"
        style={{ maxWidth: 900, margin: `0px auto` }}
      >
        <h1>Bilingual {props.pageContext.secondLanguageName} Stories</h1>
        <div className="mt-10 flex">
          {data.allStoriesJson.edges.map(({ node }) => {
            return <StoryCard key={node.title} story={node}></StoryCard>;
          })}
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query($secondLanguageName: String!) {
    allStoriesJson(
      filter: { secondLanguageName: { eq: $secondLanguageName } }
    ) {
      edges {
        node {
          id
          author
          description
          price
          secondLanguageAuthor
          secondLanguageName
          secondLanguageTitle
          title
          fields {
            slug
          }
          isPremiumStory
        }
      }
    }
  }
`;

const mapStateToProps = (state) => ({ auth: state.auth });

export default connect(mapStateToProps, {})(LanguageStoriesCollection);
